export const BUTTON_ACTION_TYPE = {
    SEARCH: 'search',
    ADD: 'add',
    CHANGE: 'change',
    EXCEL: 'excel',
    PRINT: 'print',
    SETTING: 'setting',
    SAVE: 'save',
    DELETE: 'delete',
    APPROVE: 'approve',
    SORTBYALPHA: 'sortByAlpha',
    CALCULATION: 'calculation',
    RELOAD: 'reload',
    CHECKPASS: 'checkpass',
    EDIT: 'edit',
    VIEW: 'view',
    PASSWORD: 'password',
    USER: 'user',
    DETAIL: 'detail',
    HISTORY: 'history',
    CLOSE: 'close',
    FILE: 'file',
    SYNC: 'sync',
    EXPORT_FILE: 'exportFile',
    DETAIL_ORDER: 'detailOrder',
    OFFICE: 'office',
    CART: 'cart',
    HISTORY_V2: 'historyV2',
};
